// SPLIDE JS INIT
// For Segment Page Only
//
// Nota bene: For Homepage, see the dedicated JS called only in Homepage resources

function initCarouselHlSegment() {
  const carouselElement = document.querySelector('.js_splide_hl_segment_main.splide');

  if (!carouselElement) {
    // console.warn('Carousel element not found: .js_splide_hl_segment_main.splide');
    return;
  }

  // Initialize Splide carousel
  const splideMain = new Splide(carouselElement, {
    type: 'fade',
    perMove: 1,
    drag: false,
    classes: {
      arrows: 'splide__arrows  list-unstyled d-flex justify-content-center justify-content-md-between',
      arrow : 'splide__arrow  btn btn-primary btn-round',
    },
    i18n: {
      slideLabel: '%s de %s',
      first: 'Aller au premier Temps fort',
      last: 'Aller au dernier Temps fort',
      slideX: 'Aller au Temps fort numéro %s',
      pageX: 'Aller à la page %s',
      select: 'Sélectionner un Temps fort de la Banque des Territoires',
      prev: 'Temps fort précédent',
      next: 'Temps fort suivant',
    },
    breakpoints: {
      768: {
        drag: true
      },
      666: {
        drag: true
      },
      320: {
        drag: true
      }
    },
  });

  // Event listeners
  splideMain.on('mounted move', () => {
    //console.log('Splide Main is ready (Segment)');

    // Remove the loader if it exists
    const splideLoader = document.querySelector('.js_splide_loader');
    if (splideLoader) {
      splideLoader.remove();
      //console.log('Loader removed successfully.');
    }
  });

  // Mount the Splide instance
  splideMain.mount();
}
